import React, { useEffect, useState } from 'react'
import {
  message, Table, Button, Tooltip, Tag, Badge, PageHeader, Divider, Row, Col, Spin
} from 'antd'

import { PlusOutlined, EditOutlined } from '@ant-design/icons'
import ReactCountryFlag from 'react-country-flag'

import { fetch } from '../../utils/fetch'

import UserModal from '../component/UserModal'

import UserFilter from './component/UserFilter'

const User = () => {
  const [userList, setUserList] = useState([])
  const [editItem, setEditItem] = useState(null)
  const [visible, setVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      width: 150,
    },
    {
      title: 'First name',
      dataIndex: 'firstName',
      key: 'firstName',
      width: 150,
    },
    {
      title: 'Last name',
      dataIndex: 'lastName',
      key: 'lastName',
      width: 150,
    },
    {
      title: 'Site',
      dataIndex: 'siteCode',
      key: 'siteCode',
      width: 100,
      align: 'center',
    },
    {
      title: 'Role',
      dataIndex: 'roleList',
      key: 'roleList',
      width: 200,
      align: 'center',
      render: (roles) => (
        <>
          {
            roles?.map((role) => <Tag key={`tag-${role.roleCode}`}>{role.roleDescr}</Tag>)
          }
        </>
      ),
    },
    {
      title: 'Country',
      dataIndex: 'countryCode',
      key: 'countryCode',
      width: 100,
      align: 'center',
      render: (code) => (
        <>
          <Tag icon={(
            <ReactCountryFlag
              style={{ border: '0.5px solid black' }}
              countryCode={code}
              svg
              cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
              cdnSuffix="svg"
            />
          )}
          >
            &nbsp;{code}
          </Tag>
        </>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      width: 50,
      align: 'center',
      render: (status) => (
        status ? <Badge status="success" /> : <Badge status="error" />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      align: 'center',
      render: (text, record) => (
        <Tooltip title="Edit">
          <Button type="secondary" shape="circle" icon={<EditOutlined />} onClick={() => { setEditItem(record); setVisible(true) }} />
        </Tooltip>
      ),
    },

  ]

  const getDataUser = (query) => {
    setIsLoading(true)
    fetch({
      url: '/management/user',
      query,
    }).then((res) => {
      if (res.data?.success) {
        setUserList(res.data?.data)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const onSuccess = () => {
    setVisible(false)
    setEditItem(null)
    getDataUser()
  };

  const onSearch = (query) => {
    getDataUser(query)
  }

  const onCancel = () => {
    setVisible(false)
    setEditItem(null)
  }

  useEffect(() => {
    getDataUser()
  }, [])

  return (
    <>
      <Spin spinning={isLoading} tip="Loading..."></Spin>
      <UserModal
        visible={visible}
        onSuccess={onSuccess}
        onCancel={onCancel}
        editItem={editItem}
      />
      <PageHeader
        ghost={false}
        title="User"
        extra={(
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditItem(null); setVisible(true) }} >New</Button>
        )}
      >
        <Row gutter={24}>
          <Col xs={24} md={24}>
            <UserFilter onSearch={onSearch} />
          </Col>
        </Row>
        <Divider />
        <Table dataSource={userList} columns={columns} size="small">
          <Table.Column title="Action2" />
        </Table>
      </PageHeader>
    </>
  )
}

export default User
